export default __webpack_public_path__ + "static/media/files_ln.5441ce9d.svg";